var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"breadcrumbs",on:{"click":_vm.toBrackets}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.mdiArrowLeft)+" ")]),_c('span',[_vm._v("Brackets")]),_vm._v(" / "),_c('h1',{staticClass:"breadcrumbs-battle-name"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }